// extracted by mini-css-extract-plugin
export default {"InputError":"InputError_InputError__hwH6G"};